import {createI18n, I18nOptions} from 'vue-i18n';
import BackOfficeService from "@/api/BackOfficeService";
import {nextTick} from "vue";
import {i18n} from "@/main";
import {itExist} from "@/utils/general-utils";
import ApiService from "@/api/apiService";
import AuthService from "@/api/authService";
import {LANG_RTL} from "@/i18n/i18nConfig";

export async function setupI18n(options: I18nOptions) {
  const i18n = createI18n(options);
  await loadLocaleMessages(i18n, options.locale as string);
  setI18nLanguage(i18n, options.locale as string);
  return i18n;
}

export function setI18nLanguage(i18n: any, locale: string): void {
  i18n.global.locale.value = locale;
  if (itExist(AuthService.auth)) {
    AuthService.auth.defaults.headers['IDC-Language'] = locale;
  }
  if (itExist(ApiService.api)) {
    ApiService.api.defaults.headers['IDC-Language'] = locale;
  }
  const html = document.querySelector('html');
  html?.setAttribute('lang', locale.replace('_', '-'));
  const {lang} = decomposeLocale(locale);
  html?.setAttribute('dir', LANG_RTL.includes(lang) ? 'rtl' : 'ltr');
}

export async function loadLocaleMessages(i18n: any, locale: string): Promise<any> {
  console.log('loading locale message', locale);
  try {
    const translations = await BackOfficeService.fetchLocaleText(locale);
    i18n.global.setLocaleMessage(locale, translations);
  } catch (error) {
    console.log(error);
  }
  return nextTick();
}

export function getCurrentLocale(): string {
  return i18n.global.locale.value;
}

export function decomposeLocale(locale: string): { lang: string; countryCode: string } {
  const regex = new RegExp(/^([A-Za-z]+)[-_]?([A-Za-z]*)$/);
  const [, startLocale, endLocale] = locale.match(regex) ?? [];
  return {lang: startLocale, countryCode: endLocale};
}
